const addPaymentReducer = (data = {}, action) => {
    switch(action.type){
        case 'SET_ADD_PAYMENT':
            data = action.data
            return data;
        default:
            return data;
    }
}

export default addPaymentReducer;